module.exports = __webpack_public_path__ + "static/light-switch-fccd77c65df3d6b582e7d49e0040a715.jpg";